import styled, { css } from 'styled-components'

const colorCode = {
  red: '#db3e34',
  orange: '#f39000',
  green: '#76b729'
}

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
`
const TableCaption = styled.caption`
  padding: 15px;
  font-size: 100%;
  color: ${props => props.theme[props.captionColor]};
  font-weight: ${props => props.theme.font.weight.bold};
  background: ${props => props.theme[props.captionBackground]};
  text-align: ${props => props.alignCaption};
`

const TableHeader = styled.th`
  &&& {
    border: none;
    padding: 0.5rem;
    text-align: ${props => props.alignHeader};
    color: ${props => props.theme[props.headerColor]};
    font-size: 75%;
    font-style: ${props => props.fontStyle};
    font-weight: ${props => (props.fontStyle === 'italic' ? 'normal' : props.theme.font.weight.bold)};
  }
`

const TableRow = styled.tr`
  justify-content: space-evenly;
  font-size: ${props => props.theme.font.size.base};
  line-height: normal;
  border-bottom: ${props => props.theme.color.monochrome.light} 1px solid;
  background: ${props => props.theme[props.headerBackground]};
  &:nth-child(odd) {
    background-color: ${props => props.theme.color.monochrome.lighter};
  }
`

const TableCell = styled.td`
  &&& {
    padding: 0.5rem;
    font-size: 75%;
    text-align: ${props => props.alignCellData};
    border: none;
    border-left: 1px solid ${props => props.theme.color.monochrome.light};

    ${props =>
      props.colorCoding === 'high' &&
      css`
        background: ${colorCode.red};
        border-color: ${colorCode.red};
      `}
  ${props =>
    props.colorCoding === 'medium' &&
    css`
      background: ${colorCode.orange};
      border-color: ${colorCode.orange};
    `}
  ${props =>
    props.colorCoding === 'low' &&
    css`
      background: ${colorCode.green};
      border-color: ${colorCode.green};
    `}
  }
`

export { Table, TableCaption, TableHeader, TableRow, TableCell }
